import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";


const turnosEnAtencion = async ({ branch_id, token, callbacks }) => {
    const response = await connection({ method: 'GET', url: `${ENTITY_URL.ADP.TURNOS.TURNOS_EN_ATENCION}${branch_id}`, extraHeaders: { token: token }, params: { limit: 10 } });
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}

export default turnosEnAtencion;